

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Facebook, Instagram, Phone, Mail, MapPin } from 'lucide-react';

const Footer = () => {
    const navigate = useNavigate();

    const handleScrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const handleNavigation = (path) => {

        console.log(`Navigating to: ${path}`);

        navigate(path);
        handleScrollToTop();
    };

    return (
        <footer className="bg-gray-800 text-white mt-16">
            {/* Main Footer Content */}
            <div className="py-12">
                <div className="container mx-auto px-4">
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
                        {/* Company Info */}
                        <div className="space-y-4">
                            <h3 className="text-xl font-bold text-white mb-4">Navam Biz Solutions</h3>
                            <p className="text-gray-300 text-sm leading-relaxed">
                                Empowering businesses with innovative solutions and exceptional service.
                                Your success is our mission.
                            </p>
                            <div className="flex space-x-4 pt-2">
                                <a
                                    href="https://www.facebook.com/profile.php?id=61566951353310"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="Facebook"
                                    className="text-gray-300 hover:text-white hover:scale-110 transition-all duration-300 p-2 rounded-full hover:bg-blue-600"
                                >
                                    <Facebook size={20} />
                                </a>
                                <a
                                    href="https://www.instagram.com/navambiz/profilecard/?igsh=MWphOWd1aXh6ZGM0ag%3D%3D"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="Instagram"
                                    className="text-gray-300 hover:text-white hover:scale-110 transition-all duration-300 p-2 rounded-full hover:bg-pink-600"
                                >
                                    <Instagram size={20} />
                                </a>
                            </div>
                        </div>

                        {/* Quick Links */}
                        <div className="space-y-4">
                            <h4 className="text-lg font-semibold text-white mb-4">Quick Links</h4>
                            <div className="space-y-2">
                                <button
                                    onClick={() => navigate('/about')}
                                    className="block text-gray-300 hover:text-white hover:translate-x-2 transition-all duration-300 text-left"
                                    aria-label="About Us"
                                >
                                    About Us
                                </button>
                                <button
                                    onClick={() => handleNavigation('/services')}
                                    className="block text-gray-300 hover:text-white hover:translate-x-2 transition-all duration-300 text-left"
                                    aria-label="Our Services"
                                >
                                    Services
                                </button>
                                <button
                                    onClick={() => handleNavigation('/contact')}
                                    className="block text-gray-300 hover:text-white hover:translate-x-2 transition-all duration-300 text-left"
                                    aria-label="Contact Us"
                                >
                                    Contact
                                </button>
                            </div>
                        </div>

                        {/* Legal */}
                        <div className="space-y-4">
                            <h4 className="text-lg font-semibold text-white mb-4">Legal</h4>
                            <div className="space-y-2">
                                <button
                                    onClick={() => handleNavigation('/privacy-policy')}
                                    className="block text-gray-300 hover:text-white hover:translate-x-2 transition-all duration-300 text-left"
                                    aria-label="Privacy Policy"
                                >
                                    Privacy Policy
                                </button>
                                <button
                                    onClick={() => handleNavigation('/terms')}
                                    className="block text-gray-300 hover:text-white hover:translate-x-2 transition-all duration-300 text-left"
                                    aria-label="Terms of Service"
                                >
                                    Terms of Service
                                </button>
                            </div>
                        </div>

                        {/* Contact Info */}
                        <div className="space-y-4">
                            <h4 className="text-lg font-semibold text-white mb-4">Get in Touch</h4>
                            <div className="space-y-3">
                                <div className="flex items-center space-x-3 text-gray-300 hover:text-white transition-colors duration-300">
                                    <Phone size={16} className="flex-shrink-0" />
                                    <span className="text-sm">+91 72761 56055</span>
                                </div>
                                <div className="flex items-center space-x-3 text-gray-300 hover:text-white transition-colors duration-300">
                                    <Mail size={16} className="flex-shrink-0" />
                                    <span className="text-sm">info@navambizsolutions.com</span>
                                </div>
                                <div className="flex items-start space-x-3 text-gray-300 hover:text-white transition-colors duration-300">
                                    <MapPin size={16} className="flex-shrink-0 mt-1" />
                                    <span className="text-sm">Pune, Maharashtra, India</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Bottom Bar */}
            <div className="border-t border-gray-600 bg-gray-900 bg-opacity-50">
                <div className="container mx-auto px-4 py-4">
                    <div className="flex flex-col md:flex-row justify-between items-center space-y-2 md:space-y-0">
                        <p className="text-gray-300 text-sm">
                            &copy; {new Date().getFullYear()} Navam Biz Solutions. All rights reserved.
                        </p>
                        <button
                            onClick={handleScrollToTop}
                            className="text-gray-300 hover:text-white text-sm hover:underline transition-colors duration-300 flex items-center space-x-1 group"
                            aria-label="Back to top"
                        >
                            <span>Back to Top</span>
                            <span className="transform group-hover:-translate-y-1 transition-transform duration-300">↑</span>
                        </button>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
